
import ModalCartBase from '~/components/modal/cart/Base.vue'
import CartButton from '~/components/player/CartButton.vue'

export default {
  components: {
    ModalCartBase,
    CartButton
  },
  props: {
    keyId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      product: false,
      showingSidebar: true,
      playerConfig: {},
      lesson: false,
      showCartModal: false,
      cartItemIds: [], // Will be populated with the current lesson/product ID
      wasPlaying: false, // Track if video was playing when cart opened
      isLoading: false
    }
  },
  computed: {
    shouldShowCartButton() {
      if(this.product && (this.product.user && (this.product.user.access))){
        return false
      }
      else{
        return true
      }
    }
  },
  methods: {
    async handleReload() {
      this.product = false
      this.lesson = false
      this.isLoading = true;
      try {
        const key = this.keyId.substring(1);
        await this.$store.dispatch('player/getProduct', {
          lessonId: key,
          $axios: this.$axios,
          $cookies: this.$cookies
        });
        const data = await this.$player.get(key);
        this.product = data.product;
        this.lesson = data.lesson;
        if (this.$refs.tabsyncPlayer) this.$refs.tabsyncPlayer.setup()
        if(this.$refs.lessonTabs) this.$refs.lessonTabs.setup()
        this.showCartModal = false;
      } catch (err) {
        console.error('Error reloading content:', err);
      } finally {
        this.isLoading = false;
      }
    },
    async loadInitialData() {
      console.log('Method: loadInitialData called');
      this.isLoading = true;
      try {
        console.log('loadInitialData: Fetching partnership config');
        await this.$member.partnership.fromNonce(
          this.$route.query['partner-nonce'],
          this.$route.query['partner_id']
        );

        this.playerConfig = await this.$member.config.player();
        console.log('loadInitialData: Player config set', this.playerConfig);

        this.setupStyle();

        if (this.keyId) {
          const key = this.keyId.substring(1);
          console.log('loadInitialData: Dispatching getProduct with key:', key);
  
          const data = await this.$player.get(key);
          console.log('loadInitialData: Fetched data', data);

          this.product = data.product;
          this.lesson = data.lesson;
          console.log('product user', this.product.user)
          if(!this.product.access)
            this.cartItemIds = [8004];
          else if(this.product.access && !this.product.owns)
            this.cartItemIds = [this.product.id]
        }
      } catch (err) {
        console.error('Error loading initial data:', err);
      } finally {
        this.isLoading = false;
        console.log('loadInitialData: Finished execution');
      }
    },
    pauseAllPlayers() {
      console.log('Method: pauseAllPlayers called');
      // Log pause events for players
      if (this.$refs.tabsyncPlayer) {
        console.log('pauseAllPlayers: Pausing TabSync player');
      }
      // Log video and audio elements found
      if (process.client && typeof document !== 'undefined') {
        const videoElements = document.querySelectorAll('video');
        const audioElements = document.querySelectorAll('audio');
        console.log('pauseAllPlayers: Video elements found:', videoElements);
        console.log('pauseAllPlayers: Audio elements found:', audioElements);
      }
    },
    handleCartButtonClick() {
      console.log('Method: handleCartButtonClick called');
      this.pauseAllPlayers();
      this.showCartModal = true;
      console.log('handleCartButtonClick: showCartModal set to true');
    },
    handleModalClose() {
      console.log('Method: handleModalClose called');
      this.showCartModal = false;
      console.log('handleModalClose: showCartModal set to false');
    },
    setupStyle() {
      console.log('Method: setupStyle called');
      if (process.client && typeof document !== 'undefined' && this.playerConfig && this.playerConfig.colors) {
        console.log('setupStyle: Setting up player-specific styles');
        const head = document.getElementsByTagName('head')[0],
          s = document.createElement('style')
        let cssStr = ``
        if (this.playerConfig.colors.primary) {
          const pRGB = this.playerConfig.colors.primary.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
            .substring(1).match(/.{2}/g)
            .map(x => parseInt(x, 16))
          cssStr += `:root {
            --wl-primary: ${this.playerConfig.colors.primary};
            --bs-link-color-rgb: ${pRGB[0]}, ${pRGB[1]}, ${pRGB[2]};
            --bs-link-hover-color-rgba: ${pRGB[0]}, ${pRGB[1]}, ${pRGB[2]}, 0.9;
            }`
          if (this.playerConfig.font) {
            const fontLink = document.createElement('link')
            fontLink.rel = 'stylesheet'
            // fontLink.href = `https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap`
            fontLink.href = this.playerConfig.font.url
            head.appendChild(fontLink)
            cssStr += `* {font-family:${this.playerConfig.font.family} !important} `
          }
          cssStr += `.hoverLink {transition:opacity .1s;}
            .hoverLink:hover {opacity:0.9;}
            .bg-primary {background-color:var(--wl-primary) !important;}
            .btn-primary {background-color:var(--wl-primary) !important;border-color:var(--wl-primary) !important;}
            a {color: rgb(var(--bs-link-color-rgb)) !important;}
              a:hover {color:rgba(var(--bs-link-hover-color-rgba)) !important}
            .page-link {color:rgb(var(--bs-link-color-rgb)) !important;}
            .page-link.active {
              background-color: var(--wl-primary) !important;border-color: var(--wl-primary) !important;color:white !important;}
            .form-control:focus, .form-select:focus {
              border-color:var(--wl-primary) !important;box-shadow: 0 0 0 .25rem rgba(var(--bs-link-color-rgb), .25) !important;}
            .form-check-input:focus {
              border-color:var(--wl-primary) !important;box-shadow: 0 0 0 .25rem rgba(var(--bs-link-color-rgb), .25) !important;}
            .form-check-input:checked {
              background-color:var(--wl-primary) !important;border-color:var(--wl-primary) !important;}`
        }
        s.appendChild(document.createTextNode(cssStr))
        head.appendChild(s)
      }
    },
    checkHeight(){
      if (process.client && typeof document !== 'undefined') {
        window.parent.postMessage({message: JSON.stringify({height: document.body.scrollHeight + 40})}, '*')
      }
      setTimeout(this.checkHeight, 1000)
    }
  },
  async created() {
    console.log('Lifecycle: created called');
    await this.loadInitialData();
    if (!this.product || !this.lesson) {
      console.log('Product or lesson data is missing.');
    }
  },
  beforeDestroy() {
    console.log('Lifecycle: beforeDestroy called');
    this.wasPlaying = false;
  },
  watch: {
    '$store.state.player.lesson'(newLesson) {
      console.log('Watch: $store.state.player.lesson changed', newLesson);
      if (newLesson && this.$refs.tabsyncPlayer) {
        this.$nextTick(() => {
          console.log('Watch: Refreshing tabsync player setup');
          this.$refs.tabsyncPlayer.setup();
        });
      }
      if (newLesson && this.$refs.lessonTabs) {
        this.$nextTick(() => {
          console.log('Watch: Refreshing lessontabs setup');
          this.$refs.lessonTabs.setup();
        });
      }

    }
  },
  mounted(){
    if(window && (window.parent)){
      window.parent.postMessage({message: JSON.stringify({height: 0})}, '*')
      this.checkHeight()
    }
  }
}
